<template>
    <div class="device-type-manange relative">
        <el-row>
            <el-col :span="24">
                <el-col  class="data-button" :span="2" style="right: 4em;top: 0;z-index: 2;" v-if="is_mobile">
                    <el-button type="success" @click="addWork">创建预约</el-button>
                </el-col>
                <el-col  class="data-button" :span="2" style="right: 11em;top: 0;z-index: 2;" v-if="!is_mobile">
                    <el-button type="success" @click="addWork">创建预约</el-button>
                </el-col>
                <el-col class="data-button" :span="2"  style="right: 4em;top: 0;z-index: 2;"  v-if="!is_mobile">
                    <el-button type="primary" @click="isShowHistory(true)">{{ is_history_show_txt }}</el-button>
                </el-col>
            </el-col>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="'预约处理('+reservationing_number+')'" name="1" style="color: red;" >
                <part1 ref="p1" :allType="allType" :worker_status="null_value" :worker_start_time="null_value" :worker_end_time="null_value" :userName="userName_1" :doctorName="doctorName_1"  :managerName="managerName_1"></part1>
            </el-tab-pane>
            <el-tab-pane :label="'等待会面('+reservationed_success_number+')'" name="2">
                <part2 ref="p2" :allType="allType" :worker_status="worker_status" :worker_start_time="worker_start_time" :worker_end_time="worker_end_time" :userName="userName_2" :doctorName="doctorName_2" :managerName="managerName_2"></part2>
            </el-tab-pane>

            <el-tab-pane :label="'会面完成('+reservationed_number+')'" name="3" v-if="is_history_show">
                <part3 ref="p3" :allType="allType" :worker_status="null_value" :worker_start_time="null_value" :worker_end_time="null_value" :userName="userName_3" :doctorName="doctorName_3" :managerName="managerName_3"></part3>
            </el-tab-pane>
            <el-tab-pane :label="'会面中断('+reservationed_faile_number+')'" name="4" v-if="is_history_show">
                <part4 ref="p4" :allType="allType" :worker_status="null_value" :worker_start_time="null_value" :worker_end_time="null_value" :userName="userName" :doctorName="doctorName" :managerName="managerName"></part4>
            </el-tab-pane>
        </el-tabs>


        <!-- 表单开始 -->

    </div>
</template>
<script>
    import {getUserInfos} from '@/utils/userInfos'
    import {getFormatDate} from "@/utils/date";
    import {check} from "@/utils/checkData";
    import part1 from "./WorkListPart.vue";
    import part2 from "./WorkListPart.vue";
    import part3 from "./WorkListPart.vue";
    import part4 from "./WorkListPart.vue";
    import {authUrlCheck, isMobile} from "@/api/order";

    export default {
        inject: ['work_list', 'rez_num', 'rez_status'],
         components: {
                part1,
                part2,
                part3,
                part4,
            },
        provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
            return {
                work_search: this.work_search
            }
        },
        data() {
            return {
                role_id: 0,
                null_value: '', // part1,part3，part4， 空值占位
                worker_status: '',
                worker_start_time: '',
                worker_end_time: '',
                reservationing_number: 0,
                reservationed_number: 0,
                reservationed_success_number: 0,
                reservationed_faile_number: 0,
                allType: [],
                tableData: [],
                activeName: '1',
                is_watch: false,
                is_history_show: false,
                is_history_show_txt: '历史预约',
                userName: '',
                doctorName: '',
                managerName: '',
                userName_1: '',
                doctorName_1: '',
                managerName_1: '',
                userName_2: '',
                doctorName_2: '',
                managerName_2: '',
                userName_3: '',
                doctorName_3: '',
                managerName_3: '',
                is_mobile: false,
            };
        },
        created() {
            this.is_mobile = isMobile()
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            // window
            if (this.$route.query.status > 2 || this.$route.params.status > 2) {
                this.is_history_show = false;
                this.isShowHistory()
            }
            if (this.$route.query.status) {
                this.worker_status = this.$route.query.status
                this.worker_start_time = this.$route.query.start_time
                this.worker_end_time = this.$route.query.end_time
                this.activeName = this.$route.query.status.toString()
            }
            if (this.$route.params.status) {
                this.worker_status = this.$route.params.status
                this.worker_start_time = this.$route.params.start_time
                this.worker_end_time = this.$route.params.end_time
                this.activeName = this.$route.params.status.toString()
            }

            if (this.activeName == 1) {
                this.userName_1 = this.$route.params.user_name || ''
                this.doctorName_1 = this.$route.params.doctor_name || ''
                this.managerName_1 = this.$route.params.manager_name || ''
            }
            if (this.activeName == 2) {
                this.userName_2 = this.$route.params.user_name || ''
                this.doctorName_2 = this.$route.params.doctor_name || ''
                this.managerName_2 = this.$route.params.manager_name || ''
            }
            if (this.activeName == 3) {
                this.userName_3 = this.$route.params.user_name || ''
                this.doctorName_3 = this.$route.params.doctor_name || ''
                this.managerName_3 = this.$route.params.manager_name || ''
            }

            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'work_edit' || prev_page == 'work_add' || prev_page == 'work_detail') {
                let hist_status = localStorage.getItem('work_list_status')
                if (hist_status > 0) {
                    this.activeName = hist_status
                    if (hist_status > 2) {
                        this.is_history_show = false;
                        this.isShowHistory()
                    }
                }
            }

        },
        mounted() {
            //this.getList();
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'work_edit' || prev_page == 'work_add' || prev_page == 'work_detail') {
                this.getAllReservationStatusNumber();
                let status = parseInt(localStorage.getItem('work_list_status'))
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                if (status != 1) {
                    this.reservationing_number = parseInt(localStorage.getItem('work_list_reservationing_number'))||0
                }
                if (status != 2) {
                    this.reservationed_success_number = parseInt(localStorage.getItem('work_list_reservationed_success_number'))||0
                }
                if (status != 3) {
                    this.reservationed_number = parseInt(localStorage.getItem('work_list_reservationed_number'))||0
                }
                if (status != 4) {
                    this.reservationed_faile_number = parseInt(localStorage.getItem('work_list_reservationed_faile_number'))||0
                }
                this.subWindow('p1',1);
                this.subWindow('p2',2);

                this.is_watch = true
            } else {
                this.getAllReservationStatusNumber();
                this.subWindow('p1',1);
                this.subWindow('p2',2);

                this.is_watch = true
            }
            // 通知重新检查未处理预约数
            this.work_list()

        },
        methods: {
            work_search(data) {
                if (!data.status) {
                    data.status = this.activeName
                }
                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'listing',
                    params: {
                        user_name: data.user_name,
                        user_mobile: data.user_mobile,
                        doctor_name: data.doctor_name,
                        doctor_mobile: data.doctor_mobile,
                        start_book_date: data.start_book_date,
                        end_book_date: data.end_book_date,
                        status: data.status,
                        doctor_assistant: data.doctor_assistant,
                        user_company: data.user_company,
                        doctor_hospital: data.doctor_hospital,
                        count_num: 1,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let number = res.data.data.number;
                    data.status = data.status.toString()

                    switch (data.status) {
                        case '1':
                            this.reservationing_number = number;
                            break;
                        case '2':
                            this.reservationed_success_number = number;
                            break;
                        case '3':
                            this.reservationed_number = number;
                            break;
                        case '4':
                            this.reservationed_faile_number = number;
                            break;
                    }

                });


            },
            // 所有状态的预约数量
            getAllReservationStatusNumber(status = [1, 2, 3, 4]) {

                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'allReservationStatusNumber',
                    params: {
                        status: status,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let status = parseInt(localStorage.getItem('work_list_status'))
                    let prev_page = localStorage.getItem('prev_page')
                    let res_status = 0
                    if (res.data.data && res.data.data.length > 0) {
                        for (var i = 0; i < res.data.data.length; i++) {
                            res_status = res.data.data[i].status;
                            if ((prev_page == 'work_edit' || prev_page == 'work_add' || prev_page == 'work_detail') && status == res_status) {
                                continue;
                            }
                            if (res_status == this.activeName) {
                                this.work_search({
                                    user_name: this.$route.params.user_name || this.$route.query.user_name || '',
                                    user_mobile: this.$route.params.user_mobile || this.$route.query.user_mobile || '',
                                    doctor_name: this.$route.params.doctor_name || this.$route.query.doctor_name || '',
                                    doctor_mobile: this.$route.params.doctor_mobile || this.$route.query.doctor_mobile || '',
                                    start_book_date: this.$route.params.start_book_date || this.$route.query.start_book_date || '',
                                    end_book_date: this.$route.params.end_book_date || this.$route.query.end_book_date || '',
                                    status: this.$route.params.status || this.$route.query.status || '',
                                    doctor_assistant: this.$route.params.doctor_assistant || this.$route.query.doctor_assistant || '',
                                    user_company: this.$route.params.user_company || this.$route.query.user_company || '',
                                    doctor_hospital: this.$route.params.doctor_hospital || this.$route.query.doctor_hospital || '',
                                })
                                continue;
                            }
                            switch (res_status) {
                                case '1':
                                    this.reservationing_number = res.data.data[i].number;
                                    break;
                                case '2':
                                    this.reservationed_success_number = res.data.data[i].number;
                                    break;
                                case '3':
                                    this.reservationed_number = res.data.data[i].number;
                                    break;
                                case '4':
                                    this.reservationed_faile_number = res.data.data[i].number;
                                    break;
                            }
                        }
                        this.allType = res.data.data;
                    }

                });
            },
            subWindow(w_name,status)
            {
                this.$refs[w_name].getList(status);
            },




            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            // 创建预约
            addWork() {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/work/WorkAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "workAdd", params: {}});
                localStorage.setItem('work_list_status', this.activeName)
                return;
            },

            isShowHistory(click=false) {
                this.is_history_show = !this.is_history_show
                let that = this
                if (this.is_history_show) {
                    this.is_history_show_txt = '隐藏历史预约';
                    let timer = setInterval(function () {
                        that.subWindow('p3',3);
                        that.subWindow('p4',4);
                        clearTimeout(timer)
                    }, 100)
                    if (!click) {
                        this.activeName = localStorage.getItem('work_list_status')
                    } else {
                        this.activeName = '3'
                    }
                    // localStorage.setItem('work_list_status', this.activeName)
                } else {
                    this.is_history_show_txt = '历史预约';
                    let timer = setInterval(function () {
                        that.subWindow('p1',1);
                        that.subWindow('p2',2);
                        clearTimeout(timer)
                    }, 100)
                    this.activeName = '1'
                    // localStorage.setItem('work_list_status', this.activeName)
                }

            },

            // 跳转添加页
            addHospitalType() {
                this.$router.push({name: "articleAdd", params: {}});
            },


             handleClick(tab, event) {
                 // localStorage.setItem('work_list_status', this.activeName)

            }

        },
        watch: {
            rez_num: {
                immediate: true,
                deep: true,
                handler(nVal) {
                    process.env.NODE_ENV !== 'production' && console.log(nVal)
                    if (this.is_watch) {
                        // this.subWindow('p1',1);
                        this.getAllReservationStatusNumber();
                        this.subWindow('p1',1);
                        this.subWindow('p2',2);
                    }


                },
            },
            rez_status: {
                immediate: true,
                deep: true,
                handler(nVal) {
                    process.env.NODE_ENV !== 'production' && console.log(nVal)
                    if (this.is_watch) {

                        if (this.activeName != '1') {
                            this.activeName = '1';
                            localStorage.setItem('work_list_status', this.activeName)
                        }
                    }


                },
            },
            $route:{
                immediate:true,
                handler(){

                    if(this.$route.query.status){//需要监听的参数
                        this.worker_status = this.$route.query.status
                        this.activeName = this.$route.query.status
                    }
                }
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .el-tabs__nav .is-active{
        position: relative;
    }
    .el-tabs__nav .is-active::after{
        content: "";
        position: absolute;
        bottom: 3px;
        left: 15px;
        width: 82%;
        height: 2px;
        background-color: #409EFF;

    }
    .data-button{position: absolute;}
    .history_show{display: none}
</style>
